var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTagDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.997,
    viewBox: "0 0 20 19.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_258",
    "data-name": "Subtraction 258",
    d: "M17639.357,9062.5a2.777,2.777,0,0,1-1.98-.818l-8.658-8.65a.748.748,0,0,1-.219-.526v-9.258a.748.748,0,0,1,.744-.744h9.262a.733.733,0,0,1,.523.214l8.568,8.578v.051l.086.086a2.8,2.8,0,0,1,0,3.953l-6.346,6.3A2.791,2.791,0,0,1,17639.357,9062.5Zm-9.371-18.514h0v8.216l8.438,8.426a1.32,1.32,0,0,0,1.855,0l6.354-6.352a1.272,1.272,0,0,0,.381-.917,1.313,1.313,0,0,0-.381-.936l-8.437-8.437Zm3.891,5.143a1.255,1.255,0,1,1,1.254-1.255A1.263,1.263,0,0,1,17633.877,9049.128Z",
    transform: "translate(-17628.5 -9042.502)",
    fill: "#f8f8f8",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTagDark);
export default __webpack_public_path__ + "static/media/icon-tag_dark.5a0224a5f4a1c09ac52d88da7b4ba733.svg";
export { ForwardRef as ReactComponent };